import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import { ChakraProvider, Box, Text } from '@chakra-ui/react';
import {
  FiHome,
  FiCpu,
  FiCompass,
  FiBook
} from 'react-icons/fi';

import { SidebarWithHeader, NavItem } from './components/sidebar/Sidebar';

import Login from './pages/login/Login';
import Register from './pages/register/Register';
import Dashboard from './pages/dashboard/Dashboard';
import { ProtectedRoute } from './util/security/ProtectedRoute';
import EmailAutomation from './pages/automation/EmailAutomation';
import Log from './pages/log/Log'

const ExplorePage = () => <Box><Text>Explore Page Content</Text></Box>;

const AppLayout = () => {
  const navItems = (
    <>
      <NavItem icon={FiHome} href="/dashboard">
        Home
      </NavItem>
      <NavItem icon={FiCpu} href="/automation/email">
        Email Automation
      </NavItem>
      <NavItem icon={FiBook} href="/server/log">
        Log
      </NavItem>
    </>
  );

  return (
    <ProtectedRoute>
      <SidebarWithHeader navContent={navItems}>
        {/* 2. The <Outlet> component renders the active child route */}
        <Outlet />
      </SidebarWithHeader>
    </ProtectedRoute>
  );
};


const App: React.FC = () => {
  return (
    <ChakraProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* 3. Protected routes are nested inside the layout route */}
          <Route element={<AppLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/automation/email" element={<EmailAutomation />} />
            <Route path="/server/log" element={<Log />}/>

            {/* Redirect root path to dashboard for logged-in users */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Route>

          {/* Fallback for any other path */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </ChakraProvider>
  );
};

export default App;
